import React from "react";
import {
  Box,
  TextField
} from "@mui/material";
import {Modal} from "ui-components/modal";
import {useState} from "react";
import {$modals} from "store/modals";
import {observer} from "mobx-react-lite";
import {$products} from "store/bundles/productsInBundle";
import {LoadingButton} from "@mui/lab";

const AddProductToBundleModal = observer(() => {

  const [barcode, setBarcode] = useState('');
  const [btnLoading, setBtnLoading] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = (e) => {
    e.preventDefault();
    setBtnLoading(true);
    setError(null);
    $products.addProductToBundle(barcode)
      .then(() => {
        $products.fetchProductsInBundleList($products.currentBundle.id);
        $modals.close();
      })
      .catch(err => {
        if (err.response) {
          setError(err.response.data.message);
        }
      })
      .finally(() => setBtnLoading(false));
  }

  return (
    <Modal title="Добавить товар в текущий бандл" subheader="Введите штрих-код товара">
      <form onSubmit={e => onSubmit(e)}>
        <TextField
          name="barcode"
          inputProps={{inputMode: 'numeric', pattern: '[0-9]*'}}
          error={!!error}
          required
          onChange={e => setBarcode(e.target.value)}
          fullWidth sx={{mb: 3}}
          label="Введите штрихкод товара"
          variant="outlined"
          helperText={error}
        />
        <Box sx={{textAlign: 'right'}}>
          <LoadingButton
            variant="contained"
            type="submit"
            loading={btnLoading}
          >
            Сохранить
          </LoadingButton>
        </Box>
      </form>
    </Modal>
  )
});

export default AddProductToBundleModal;